import {
    GetContentList,
    DeleteContent,
    CreateContent,
    GetContent,
    UpdateContent,
} from '@src/services/content'

export const state = {
    contentList: [],
}

export const getters = {
    totalList(state) {
        return state.contentList.data ?
            state.contentList.data.totalItemCount :
            0
    },
}

export const mutations = {
    SET_LIST(state, newList) {
        state.contentList = newList
    },
    NEXT_PAGE_LIST(state, newList) {
        newList.forEach((content) => {
            state.contentList.data.items.push(content)
        })
    },
}

export const actions = {
    async fetchList({ commit }, parameters = {}) {
        const resp = await GetContentList(parameters)
        if (resp.status === 200) {
            commit('SET_LIST', resp.data)
        }
    },
    async deleteContent({ dispatch }, contentPublicId) {
        const resp = await DeleteContent(contentPublicId)
        if (resp.status === 200) {
            dispatch('fetchList')
        }
        return resp
    },
    async createContent({ _ }, contentForm) {
        const resp = await CreateContent(contentForm)
        return resp
    },
    async setContentForm({ _ }, contentPublicId) {
        const resp = await GetContent(contentPublicId)
        return resp
    },
    async updateContent({ _ }, content) {
        const resp = await UpdateContent(content)
        return resp
    },
    async nextPage({ commit }, currentPage) {
        const resp = await GetContentList(currentPage)
        if (resp.status === 200) {
            commit('NEXT_PAGE_LIST', resp.data.data.items)
        }
    },
}